// dependencies
import * as Sentry from "@sentry/react";
import React from "react";
import type { LoaderFunctionArgs } from "react-router-dom";

import AssignmentLog from "./AssignmentLog";

// hooks
import { currentUserQuery, reviewCycleLogsQuery, reviewCycleMetaQuery } from "../../../api/queries";
import { type SimplifiedQuery, dataLoader } from "../../../api/queries/dataLoader";

import config from "./config";

const { pageSize } = config;

// Data loader function
export const assignmentLogLoader = ({ params }: LoaderFunctionArgs) => {
	const reviewCycleId = params.cycleId;

	const queries: (() => SimplifiedQuery)[] = [];

	if (reviewCycleId) {
		queries.push(
			() =>
				reviewCycleLogsQuery({
					resourceTypes: ["review-cycle"],
					resourceIds: [reviewCycleId],
					changeTypes: ["automated-add-subject", "add-subject", "remove-subject"],
					limit: pageSize,
					skip: 0,
				}),
			() => reviewCycleMetaQuery(reviewCycleId)
		);
	}

	return dataLoader([[currentUserQuery], queries]);
};

const ViewAssignmentLog = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<AssignmentLog pageSize={pageSize} />
		</Sentry.ErrorBoundary>
	);
};

export default ViewAssignmentLog;
